import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";
import { AuthApi } from "./api/user/AuthApi";
import { UserApi } from "./api/user/userApi";
import { OLGPRSApi } from "./api/olgprs/OLGPRSApi";
import { OCMMSApi } from "./api/ocmms/OCMMSApi";
import { OHSApi } from "./api/ohs/OHSApi";
import { OverallApi } from "./api/overall/OverallApi";
import { MasterApi } from "./api/master/MasterApi";

export const store = configureStore({
  reducer: {
    User: UserReducer,
    [AuthApi.reducerPath]: AuthApi.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
    [OLGPRSApi.reducerPath]: OLGPRSApi.reducer,
    [OCMMSApi.reducerPath]: OCMMSApi.reducer,
    [OHSApi.reducerPath]: OHSApi.reducer,
    [OverallApi.reducerPath]: OverallApi.reducer,
    [MasterApi.reducerPath]: MasterApi.reducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      AuthApi.middleware,
      UserApi.middleware,
      OLGPRSApi.middleware,
      OCMMSApi.middleware,
      OHSApi.middleware,
      OverallApi.middleware,
      MasterApi.middleware,
    ]),
});
